import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    groupPaperListLoading: false,
    groupPaperListSuccess: null,
    groupPaperListError: '',

    getGroupPaperLoading: false,
    getGroupPaperSuccess: null,
    getGroupPaperError: '',

    createGroupPaperLoading: false,
    createGroupPaperSuccess: {},
    createGroupPaperError: '',
    grpStudentsListLoading: false,
    grpStudentsListSuccess: {},
    grpStudentsListError: ''
}

export const groupPaperSlice = createSlice({
    name: 'GroupPaper',
    initialState,
    reducers: {
        setGroupPaperListLoading: (state) => {
            state.groupPaperListLoading = true;
            state.groupPaperListSuccess = null;
            state.groupPaperListError = '';
        },
        setGroupPaperListSuccess: (state, action) => {
            state.groupPaperListLoading = false;
            state.groupPaperListSuccess = action.payload;
            state.groupPaperListError = '';
        },
        setGroupPaperListError: (state, action) => {
            state.groupPaperListLoading = false;
            state.groupPaperListSuccess = null;
            state.groupPaperListError = action.payload;
        },
        setGetGroupPaperLoading: (state) => {
            state.getGroupPaperLoading = true;
            state.getGroupPaperSuccess = {};
            state.getGroupPaperError = '';
        },
        setGetGroupPaperSuccess: (state, action) => {
            state.getGroupPaperLoading = false;
            state.getGroupPaperSuccess = action.payload;
            state.getGroupPaperError = '';
        },
        setGetGroupPaperError: (state, action) => {
            state.getGroupPaperLoading = false;
            state.getGroupPaperSuccess = {};
            state.getGroupPaperError = action.payload;
        },
        setCreateGroupPaperLoading: (state) => {
            state.createGroupPaperLoading = true;
            state.createGroupPaperSuccess = {};
            state.createGroupPaperError = '';
        },
        setCreateGroupPaperSuccess: (state, action) => {
            state.createGroupPaperLoading = false;
            state.createGroupPaperSuccess = action.payload;
            state.createGroupPaperError = '';
        },
        setCreateGroupPaperError: (state, action) => {
            state.createGroupPaperLoading = false;
            state.createGroupPaperSuccess = {};
            state.createGroupPaperError = action.payload;
        },
        setGrpStudentsListLoading: (state) => {
            state.grpStudentsListLoading = true;
            state.grpStudentsListSuccess = null;
            state.grpStudentsListError = '';
        },
        setGrpStudentsListSuccess: (state, action) => {
            state.grpStudentsListLoading = false;
            state.grpStudentsListSuccess = action.payload;
            state.grpStudentsListError = '';
        },
        setGrpStudentsListError: (state, action) => {
            state.grpStudentsListLoading = false;
            state.grpStudentsListSuccess = null;
            state.grpStudentsListError = action.payload;
        },
        resetGroupPaperDetails: (state) => {
            state.getGroupPaperSuccess = {};
            state.createGroupPaperSuccess = {};
        },
    }
})

export const { setGroupPaperListLoading, setGroupPaperListSuccess, setGroupPaperListError,
    setGetGroupPaperLoading, setGetGroupPaperSuccess, setGetGroupPaperError,
    setCreateGroupPaperLoading, setCreateGroupPaperSuccess, setCreateGroupPaperError,
    resetGroupPaperDetails, setGrpStudentsListLoading, setGrpStudentsListSuccess, setGrpStudentsListError
} = groupPaperSlice.actions;


export default groupPaperSlice.reducer;